import * as React from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import {
  COLLABORATOR_DETAIL_REGEX,
  DEVICES,
  FARM_DETAIL_REGEX,
  STORE_DETAIL_REGEX,
} from 'utils';

import LoadingChangeAccountModalDesktop from './LoadingChangeAccountModalDesktop';
import LoadingChangeAccountModalMobile from './LoadingChangeAccountModalMobile';

const LoadingChangeAccountModal = (): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const param = useParams();
  const location = useLocation();

  const isHideLoading = React.useMemo(
    () =>
      location.pathname.includes('/sign-in') ||
      location.pathname.includes('/forgot-password') ||
      location.pathname.includes('/sign-up') ||
      location.pathname.includes('/account/list') ||
      location.pathname.includes('/farm/create') ||
      location.pathname.includes('/store/create') ||
      location.pathname.includes('/transport/create') ||
      location.pathname.includes('/warehouse/create') ||
      location.pathname.includes('/account') ||
      FARM_DETAIL_REGEX.test(location.pathname) ||
      STORE_DETAIL_REGEX.test(location.pathname) ||
      COLLABORATOR_DETAIL_REGEX.test(location.pathname) ||
      location.pathname.includes('/collaborator/create'),
    [location.pathname, appDevice.device, param]
  );

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <LoadingChangeAccountModalDesktop isHideLoading={isHideLoading} />
    ),
    [DEVICES.MOBILE]: (
      <LoadingChangeAccountModalMobile isHideLoading={isHideLoading} />
    ),
    [DEVICES.TABLET]: (
      <LoadingChangeAccountModalMobile isHideLoading={isHideLoading} />
    ),
  };

  return renderElements[appDevice.device];
};

export default LoadingChangeAccountModal;
